<div>
    <form [formGroup]="createForm">
        <div class="grid mt-2">
            <div class="col-12 pb-3 pt-0 pl-0 pr-0">

                <!-- Select Project -->
                <div class="w-full mb-3">
                    <p-dropdown
                        formControlName="project"
                        [options]="projectsList"
                        optionLabel="codeName"
                        placeholder="Select Project"
                        appendTo="body"
                        [loading]="isLoadingProjects"
                        [filter]="true"
                        filterBy="codeName"
                        styleClass="w-full"
                        (onChange)="onProjectChange($event)"
                    />
                    @if(isInvalid('project')) {
                        <small class="p-error block mt-1">Project is required</small>
                    }
                </div>

                <!-- Select Role -->
                <div class="w-full mb-3">
                    <p-dropdown
                        formControlName="role"
                        [options]="rolesList"
                        optionLabel="roleType"
                        placeholder="Select Role"
                        appendTo="body"
                        [loading]="isLoadingRoles"
                        styleClass="w-full"
                        (onChange)="onRoleChange($event)"
                    />
                    @if(isInvalid('role')) {
                        <small class="p-error block mt-1">Role is required</small>
                    }
                </div>

                <!-- Select Candidate -->
                <div class="w-full mb-3">
                    <p-dropdown
                        formControlName="candidate"
                        [options]="candidatesList"
                        optionLabel="fullName"
                        placeholder="Select Candidate"
                        appendTo="body"
                        [loading]="isLoadingCandidates"
                        [filter]="true"
                        filterBy="fullName"
                        styleClass="w-full"
                    />
                    @if(isInvalid('candidate')) {
                        <small class="p-error block mt-1">Candidate is required</small>
                    }
                </div>

                <!-- Select Timezone -->
                <div class="w-full mb-3">
                    <p-dropdown
                        formControlName="timezone"
                        [options]="timezonesList"
                        optionLabel="val"
                        placeholder="Select Timezone"
                        appendTo="body"
                        [filter]="true"
                        filterBy="val,name"
                        styleClass="w-full"
                    />
                    @if(isInvalid('timezone')) {
                        <small class="p-error block mt-1">Timezone is required</small>
                    }
                </div>

                <!-- Start Date & Time + End Date & Time + Duration -->
                <div class="grid grid-nogutter align-items-stretch">
                    <div class="col-8">
                        <!-- Start Date & Time -->
                        <div class="grid grid-nogutter">
                            <div class="p-0 pt-2 col-12">
                                <span class="h6">{{'Start Time' | sentenceCase}}</span>
                            </div>
                            <div class="p-0 pt-2 col-12 xl:col-6 lg:col-6">
                                <p-floatLabel>
                                    <p-calendar
                                        formControlName="start_date"
                                        inputId="start_date"
                                        placeholder="mm/dd/yy"
                                        appendTo="body"
                                    />
                                </p-floatLabel>
                                @if(isInvalid('start_date')) {
                                    <small class="p-error block mt-1">Start date is required</small>
                                }
                            </div>
                            <div class="p-0 pt-2 col-12 xl:col-6 lg:col-6 pl-0 xl:pl-4 lg:pl-4">
                                <p-calendar
                                    inputId="start_time"
                                    formControlName="start_time"
                                    [timeOnly]="true"
                                    hourFormat="12"
                                    styleClass="slider-style"
                                />
                                @if(isInvalid('start_time')) {
                                    <small class="p-error block mt-1">Start time is required</small>
                                }
                            </div>
                        </div>

                        <!-- End Date & Time -->
                        <div class="grid grid-nogutter mt-3">
                            <div class="p-0 pt-2 col-12">
                                <span class="h6">{{'End Time' | sentenceCase}}</span>
                            </div>
                            <div class="p-0 pt-2 col-12 xl:col-6 lg:col-6">
                                <p-floatLabel>
                                    <p-calendar
                                        formControlName="end_date"
                                        inputId="end_date"
                                        placeholder="mm/dd/yy"
                                        appendTo="body"
                                    />
                                </p-floatLabel>
                                @if(isInvalid('end_date')) {
                                    <small class="p-error block mt-1">End date is required</small>
                                }
                            </div>
                            <div class="p-0 pt-2 col-12 xl:col-6 lg:col-6 pl-0 xl:pl-4 lg:pl-4">
                                <p-calendar
                                    inputId="end_time"
                                    formControlName="end_time"
                                    [timeOnly]="true"
                                    hourFormat="12"
                                    styleClass="slider-style"
                                />
                                @if(isInvalid('end_time')) {
                                    <small class="p-error block mt-1">End time is required</small>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="col-4 flex flex-column align-items-center justify-content-center border-1 border-round ml-3" style="max-width: calc(33.33% - 1rem); border-color: var(--primary-200) !important;">
                        <span class="text-xs text-500 mb-1">Duration</span>
                        <span class="font-semibold text-sm">{{ duration }}</span>
                    </div>
                </div>

                <!-- Notes -->
                <div class="pt-3">
                    <p-floatLabel>
                        <textarea id="notes" formControlName="notes" rows="4" pInputTextarea class="w-full"></textarea>
                        <label for="notes">Notes</label>
                    </p-floatLabel>
                </div>

                <!-- Actions -->
                <div class="flex justify-content-end mt-3 gap-2">
                    <p-button
                        label="cancel"
                        [outlined]="true"
                        [rounded]="true"
                        size="large"
                        (onClick)="cancel(false)"
                    />
                    <p-button
                        label="create"
                        [rounded]="true"
                        size="large"
                        styleClass="freshgreen-background"
                        (onClick)="onSubmit()"
                    />
                </div>

            </div>
        </div>
    </form>
</div>
